var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboardDocsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 3,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.9168 17.1666V26.4999H16.4085C14.5768 26.4999 13.0835 27.9933 13.0835 29.8249V17.1666C13.0835 12.4999 14.2502 11.3333 18.9168 11.3333H27.0835C31.7502 11.3333 32.9168 12.4999 32.9168 17.1666Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9168 26.5V30.5833C32.9168 32.835 31.0852 34.6667 28.8335 34.6667H17.1668C14.9152 34.6667 13.0835 32.835 13.0835 30.5833V29.825C13.0835 27.9933 14.5768 26.5 16.4085 26.5H32.9168Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6668 18.0417H18.3335C17.8552 18.0417 17.4585 17.6451 17.4585 17.1667C17.4585 16.6884 17.8552 16.2917 18.3335 16.2917H27.6668C28.1452 16.2917 28.5418 16.6884 28.5418 17.1667C28.5418 17.6451 28.1452 18.0417 27.6668 18.0417Z",
    fill: "#121212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1668 22.125H18.3335C17.8552 22.125 17.4585 21.7283 17.4585 21.25C17.4585 20.7717 17.8552 20.375 18.3335 20.375H24.1668C24.6452 20.375 25.0418 20.7717 25.0418 21.25C25.0418 21.7283 24.6452 22.125 24.1668 22.125Z",
    fill: "#999999"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardDocsActive);
export default __webpack_public_path__ + "static/media/onboard-docs-active.3814f970784e401099ae7d03f17a2341.svg";
export { ForwardRef as ReactComponent };